import React from 'react';
import _ from 'lodash';
import { Button, Box, Stack, Typography, TableContainer, Table, TableHead, TableRow, TableBody, TableCell, Paper } from '@mui/material';

export const SimpleView = props => {
  const { data, allCamps } = props;

  const getLabel = camp => {
    const filteredCamp = _.filter(allCamps, obj => {
      if (obj.value === camp) {
        return obj;
      }
    });

    return filteredCamp[0].label;
  };

  const getReservedSlots = camp => {
    const slot = _.filter(data.slots, slot => slot.camp === camp).shift();
    if (slot) {
      return slot.reserved_slots;
    }

    return 0;

  };

  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell align="center">Turnus</TableCell>
            <TableCell align="center">Liczba wolnych miejsc</TableCell>
            <TableCell align="center">Liczba zarezerwowanych miejsc</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.camps.map(camp => (
            <TableRow
              key={camp}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >

              <TableCell align="center">
                {getLabel(camp)}
              </TableCell>
              <TableCell align="center">
                {data.camp_slot_dict[camp].length > 0 ? data.camp_slot_dict[camp][0] : ''}
              </TableCell>
              <TableCell align="center">
                {getReservedSlots(camp)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
